import {GenericItemsUtils, IGetAllParams, GenericItemsForm, BaseGenericItemsStore, MuiDataGrid, MuiIcons, useTheme} from "@leap4/frontend";
import {IPublisherTag} from "@leap4/entities-discrepancy-common"
import {publisherTagsBaseUrl} from "../../../../config/generals";
import {urlService} from "../../../routing/urlsService";
import {Link} from "react-router-dom"
import {RootState} from "../../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";

const { Airplay } = MuiIcons;
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;

const fields = {
    name: 1,
    dataPoint: 1,
    campaignId: 1,
}

const populate = [{path: "dataPoint", select: {name: 1}}];

const getParams: IGetAllParams = {
    fields,
    populate
}

let columns: GridColDef[];
let store: BaseGenericItemsStore<IPublisherTag & { _id: string, isActive: boolean }>

function setStoreAndColumns(theme) {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${publisherTagsBaseUrl}`
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.publisherTag(id, true)},
        isActive: {},
        updated: {},
        created: {}
    })

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;

    const dataPointCol = columns.find(x=> x.field === "dataPoint");
    dataPointCol.renderCell = (params: GridRenderCellParams) =>
        <Link to={urlService.editDataPoint((params.value as any)._id)}><strong style={{color: theme.palette.text.primary}} >{(params.value as any).name}</strong></Link>
    dataPointCol.valueFormatter = (value: any) => value?.name || 'Un-Named'
}
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const PublisherTagsDashboardModule = (props:PropsFromRedux) => {
    const theme=useTheme()
    setStoreAndColumns(theme);

    return (
            <GenericItemsForm
                organization={props.selectedOrganization}
                columns={columns}
                store={store}
                breadcrumbs={{
                    link: urlService.publisherTags(),
                    text: "Publisher Tags Dashboard",
                    icon: <Airplay />
                }}
                tableProps={{pageSize: 100, style: {minHeight: "75vh"}}}
                getAllParams={getParams}
            />
    );
};


export default connector(PublisherTagsDashboardModule);